import { Injectable } from "@angular/core";
import { ICartProduct } from "@shared/interfaces";
import { Subject } from "rxjs";



@Injectable()
export class CartService {

  private removeSub$ = new Subject();

  listenRemove() {
    return this.removeSub$.asObservable();
  }

  removeCartItem(cart_id: number) {
    this.removeSub$.next(cart_id);
  }

  getCarts() {
    const cart = localStorage.getItem('cart');
    if(cart) {
      return JSON.parse(cart);
    }
    return [];
  }

  setCarts(carts: ICartProduct[]) {
    localStorage.setItem('cart', JSON.stringify(carts));
    this.updateCount();
  }

  removeCarts() {
    localStorage.removeItem('cart');
    localStorage.removeItem('cart_count');
  }

  removeCartByID(cart_id: number) {
    const carts = localStorage.getItem('cart');
    if(carts) { 
      //const carts_count = Number(JSON.parse(carts)?.length);
      let allCarts: ICartProduct[] = JSON.parse(carts);
      allCarts = allCarts.filter((o) => o.product.id !== cart_id);
      //allCarts.splice(cart_id, 1);
      localStorage.setItem('cart', JSON.stringify(allCarts));
      //localStorage.setItem('cart_count', String(carts_count - 1));
    }
  }

  updateCount() {
    const carts = localStorage.getItem('cart');
    if(carts) { 
      const carts_count = JSON.parse(carts)?.length;
      localStorage.setItem('cart_count', carts_count.toString());
    } else {
      localStorage.setItem('cart_count', '0');
    }
  }

}